import React, { Component } from 'react'
import { Button, ButtonGroup, Form, Col, Row } from 'react-bootstrap'
import Geocode from "react-geocode";
import '../css/RightMenu.css'


Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
Geocode.setLanguage("en");
Geocode.setRegion("il");
Geocode.setLocationType("ROOFTOP");

class RightMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: 1,
            placeholder: "הקלד כתובת",
            text: '',
            cities_str: ["Tel Aviv-Yafo, Israel", "Jerusalem, Israel", "Haifa, Israel", "Ramat Gan, Israel", "Petah Tikva, Israel", "Rishon LeZion, Israel", "Netanya, Israel", "Be'er Sheva, Israel", "Bnei Brak, Israel", "Bat Yam, Israel", "Holon, Israel", "Ashdod, Israel", "Herzliya, Israel", "Kefar Sava, Israel", "Ra'anana, Israel", "Nazareth, Israel", "Hadera, Israel", "Ashkelon, Israel", "Rehovot, Israel", "Bet Shemesh, Israel", "Modi'in-Maccabim-Re'ut, Israel", "Lod, Israel", "Ramla, Israel"]
        }
    }

    async getCoords(input) {
        if (input !== '') {
            const response = await Geocode.fromAddress(input);
            if (response.status === 'OK') {
                const val = response.results[0].geometry.location;
                var point = { "lat": val["lat"], "lng": val["lng"] };
                if (response.results[0].geometry.location_type === "APPROXIMATE" && this.state.cities_str.includes(response.results[0].formatted_address)) {
                    this.props.onClickShowCity(response.results[0].formatted_address);
                }
                else {
                    this.props.onClickShowCluster(point);
                }
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                <Col lg={6} xl={6} xxl={6} className='Menu' >
                    <Row>
                        <ButtonGroup aria-label="Basic example" vertical>
                            <Button className="remove-padding"
                                variant={this.props.model === 1 ? "primary" : "outline-primary"}
                                onClick={() => { this.props.onClickUpdateModel(1); }}
                            >חלוקה מבוססת רשויות מוניציפליות</Button>
                            <Button className="remove-padding"
                                variant={this.props.model === 2 ? "primary" : "outline-primary"}
                                onClick={() => { this.props.onClickUpdateModel(2); }}
                            >הצעה לחלוקה חדשה</Button>
                        </ButtonGroup>
                    </Row>
                    <Row>
                        {(this.state.selected === 2 || this.state.selected === 3) && <h6 style={{ display: "inlineBlock", marginTop: "2%" }}>הצג:</h6>}
                        {(this.state.selected === 2 || this.state.selected === 3) &&
                            <ButtonGroup aria-label="Basic example" size="sm">
                                <Button className="remove-padding"
                                    onClick={() => {
                                        this.props.appShowPolicy["kalpies"] = !this.props.appShowPolicy["kalpies"];
                                        this.props.onClickUpdateShow("kalpies");
                                    }}
                                    variant={this.props.appShowPolicy["kalpies"] ? "info" : "light"}
                                > קלפיות </Button>
                                <Button className="remove-padding"
                                    onClick={() => {
                                        this.props.appShowPolicy["numbers"] = !this.props.appShowPolicy["numbers"];
                                        this.props.onClickUpdateShow("numbers");
                                    }}
                                    variant={this.props.appShowPolicy["numbers"] ? "info" : "light"}
                                > מספור </Button>
                                <Button className="remove-padding"
                                    onClick={() => {
                                        this.props.appShowPolicy["polygons"] = !this.props.appShowPolicy["polygons"];
                                        this.props.onClickUpdateShow("polygons");
                                    }}
                                    variant={this.props.appShowPolicy["polygons"] ? "info" : "light"}
                                > גבולות </Button>
                            </ButtonGroup>
                        }
                    </Row>
                    <Row>
                        {this.state.selected === 3 &&
                            <ButtonGroup vertical aria-label="Basic example">
                                <Button className="remove-padding" style={{ marginTop: "4%" }}
                                    onClick={() => {
                                        this.getCoords(this.state.text);
                                    }}>חפש
                                </Button>
                            </ButtonGroup>
                        }
                    </Row>
                </Col>
                <Col lg={6} xl={6} xxl={6} className='Menu'>
                    <Row>
                        <ButtonGroup vertical aria-label="Basic example">
                            <Button className="remove-padding" onClick={() => {
                                this.setState({ selected: 1 });
                                this.props.onClickRestartMap();
                            }}
                                variant={this.state.selected === 1 ? "success" : "outline-success"}>אפס את המפה</Button>

                            <Button className="remove-padding" onClick={() => {
                                this.setState({ selected: 2 })
                                this.props.onClickSeeAll();
                            }}
                                variant={this.state.selected === 2 ? "success" : "outline-success"}>הצג את כל המחוזות</Button>
                            <Button className="remove-padding" onClick={() => this.setState({ selected: 3 })}
                                variant={this.state.selected === 3 ? "success" : "outline-success"}> איפה אני מצביע?</Button>
                        </ButtonGroup>
                    </Row>
                    {this.state.selected === 3 &&
                        <Form>
                            <Form.Group>
                                <Form.Control
                                    defaultValue={this.state.text}
                                    as="textarea"
                                    onChange={e => {
                                        this.setState({
                                            text: e.target.value
                                        });
                                    }}
                                    rows={3} cols={13} placeholder="הקלד כתובת או עיר" />
                            </Form.Group>
                        </Form>}
                </Col>
            </React.Fragment >);
    }

}
export default RightMenu;